import React, { useEffect, useState } from "react";
import "./Shift.css";
import { BsPencil } from "react-icons/bs";
import { PlusOutlined, StopOutlined } from "@ant-design/icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import {
  AddShifts,
  BASE_URL,
  DeleteShifts,
  FetchShifts,
  UpdateShifts,
} from "../../utils/constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import ShiftForm from "../../Pages/AddShift/ShiftForm";
import { setShft } from "../../store/slices/shiftSlice";
import { useDispatch } from "react-redux";
import ModalConfirm from "../../common/modalConfirm";

function Shift() {
  const dispatch = useDispatch();

  const [shiftsData, setShiftsData] = useState([]);
  const [shiftsDisabledData, setShiftsDisabledData] = useState([]);
  const [formVisible, setFormVisible] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [modalDeleteShiftVisible, setModalDeleteShiftVisible] = useState(false);
  const [deleteShiftData, setDeleteShiftData] = useState(null);

  const deleteShift = (params) => {
    setModalDeleteShiftVisible(true);
    setDeleteShiftData(params);
  };
  const handleOk = (params) => {
    handleDelete(params);
    setModalDeleteShiftVisible(false);
  };
  const handleCancel = () => {
    setModalDeleteShiftVisible(false);
  };
  const [activeShiftData, setActiveShiftData] = useState(null);
  const [modalActiveShiftVisible, setModalActiveShiftVisible] = useState(false);

  const activeBtnShift = (params) => {
    setModalActiveShiftVisible(true);
    setActiveShiftData(params);
  };
  const handleActiveOk = (params) => {
    activeShift(params);
    setModalActiveShiftVisible(false);
  };
  const handleActiveCancel = () => {
    setModalActiveShiftVisible(false);
  };
  const gridOptions = {
    getRowClass: (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return "RowColor";
      }
    },
  };
  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const showForm = (item) => {
    setFormVisible(true);
  };
  const hideForm = () => {
    setFormVisible(false);
    setEditItem(null);
  };
  const updateShift = (data) => {
    const token = localStorage.getItem("authToken");

    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${UpdateShifts}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const data = await response.json();
        getShiftsList();
      } else {
        const data = await response.json();
        console.log("Shiftserr", data);
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
    fetchData();
  };
  const addShift = (data) => {
    const token = localStorage.getItem("authToken");
    const FinalAdddesignation = {
      shifts: [data],
    };
    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${AddShifts}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(FinalAdddesignation),
      });

      if (response.ok) {
        const data = await response.json();
        getShiftsList();
      } else {
        const data = await response.json();
        console.log("Shiftserr", data);
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
    fetchData();
  };
  const handleAddOrUpdate = (data) => {
    if (data?.shiftId) {
      updateShift(data);
    } else {
      addShift(data);
    }
    setEditItem(null);
    hideForm();
  };
  const handleDelete = async (shiftsIndex) => {
    const shiftsId = shiftsData[shiftsIndex].shiftId;
    const token = localStorage.getItem("authToken");

    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${DeleteShifts}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          shiftId: shiftsId,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        getShiftsList();
      } else {
        const data = await response.json();
        console.log("departmenterr", data);
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
    await fetchData();
  };
  const handleDisabledEdit = (shiftsIndex) => {
    const shifts = shiftsDisabledData[shiftsIndex];

    setEditItem(null);
    setEditItem(shifts);
    showForm();
  };
  const handleEdit = (shiftsIndex) => {
    const shifts = shiftsData[shiftsIndex];
    setEditItem(null);
    setEditItem(shifts);
    showForm();
  };
  const activeShift = async (data) => {
    const updatedState = { ...data };
    delete updatedState.activeStaff;
    delete updatedState.boOwnerId;
    delete updatedState.isActive;
    delete updatedState.createdBy;
    delete updatedState.isAssigned;
    delete updatedState.createdAt;
    delete updatedState.updatedAt;
    delete updatedState.updatedBy;
    delete updatedState.isDeleted;
    delete updatedState.color;
    updatedState.isActive = true;
    updateShift(updatedState);
  };
  useEffect(() => {
    getShiftsList();
  }, []);
  const getShiftsList = async () => {
    const token = localStorage.getItem("authToken");

    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${FetchShifts}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          requiredActiveUserCount: true,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        const activeShifts = data.data.filter((item) => item.isActive);
        const disabledShifts = data.data.filter(
          (item) => item.isActive == false
        );
        setShiftsData(activeShifts);
        setShiftsDisabledData(disabledShifts);
        const newArray = activeShifts.map((item) => ({
          value: item.shiftFullName,
          key: item.shiftId,
        }));

        sessionStorage.setItem("shift", JSON.stringify(newArray));
        dispatch(setShft(newArray));
      } else {
        const data = await response.json();
        console.log("shiftserr", data);
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
    await fetchData();
  };
  const columns = [
    {
      headerName: "Full Name",
      field: "shiftFullName",
      width: "150px",
    },
    {
      headerName: "Name",
      field: "shiftShortName",
      width: "100px",
    },
    {
      headerName: "Description",
      field: "shiftDescription",
      width: "150px",
    },

    {
      headerName: "Time",
      field: "time",
      width: "110px",
      cellRenderer: (params) => {
        return (
          <>
            <div>
              <div>{` ${formatTimeWithAMPM(params.data.time.start)}`}</div>
              <p style={{ marginLeft: "16px" }}>|</p>
              <div>{` ${formatTimeWithAMPM(params.data.time.end)}`}</div>
            </div>
          </>
        );
      },
    },
    {
      headerName: "Late/Early Time",
      field: "shiftLateEarlyTime",
      width: "175px",
    },
    {
      headerName: "OT",
      field: "shiftOTEnable",
      width: "90px",
      cellRenderer: (params) => {
        return (
          <>
            <span
              style={{
                color: params.data.shiftOTEnable == "Yes" ? "green" : "red",
              }}
            >
              {params.data.shiftOTEnable}
            </span>
          </>
        );
      },
    },
    {
      headerName: "Shift HD Limits",
      field: "shiftHDLimits",
      width: "140px",

      cellRenderer: (params) => {
        return (
          <>
            <div>
              <div>{params.data.shiftHDLimits.start}</div>
              <p style={{ marginLeft: "16px" }}>|</p>
              <div>{params.data.shiftHDLimits.end}</div>
            </div>
          </>
        );
      },
    },

    {
      headerName: "Min.Working Hrs",
      field: "shiftMinWorkingHrs",
      flex: 1,
    },

    {
      headerName: "Less Time After",
      field: "shiftLessTimeAfter",
      flex: 1,
    },
    {
      headerName: "OT after",
      field: "shiftMarkOTAfter",
    },
    {
      headerName: "Actions",
      field: "actions",
      width: "100px",
      cellRenderer: (params) => {
        return (
          <>
            <div className="flex">
              {!params.data.isAssigned && (
                <>
                  <span className="shi-pen">
                    <BsPencil onClick={() => handleEdit(params.data.key)} />
                  </span>
                  <span className="shi-not ml-2">
                    <StopOutlined
                      onClick={() => deleteShift(params.data.key)}
                    />
                  </span>
                </>
              )}
            </div>
          </>
        );
      },
    },
  ];
  const disabledColumns = [
    {
      headerName: "Full Name",
      field: "shiftFullName",
      filter: true,
      width: "150px",
    },
    {
      headerName: "Name",
      field: "shiftShortName",
      filter: true,
      width: "100px",
    },
    {
      headerName: "Description",
      field: "shiftDescription",
      filter: true,
      width: "150px",
    },

    {
      headerName: "Time",
      field: "time",
      filter: true,
      width: "110px",
      cellRenderer: (params) => {
        return (
          <>
            <div>
              <div>{` ${formatTimeWithAMPM(params.data.time.start)}`}</div>
              <p style={{ marginLeft: "16px" }}>|</p>
              <div>{` ${formatTimeWithAMPM(params.data.time.end)}`}</div>
            </div>
          </>
        );
      },
    },
    {
      headerName: "Late/Early Time",
      field: "shiftLateEarlyTime",
      filter: true,
      width: "175px",
    },
    {
      headerName: "OT",
      field: "shiftOTEnable",
      filter: true,
      width: "90px",
      cellRenderer: (params) => {
        return (
          <>
            <span
              style={{
                color: params.data.shiftOTEnable == "Yes" ? "green" : "red",
              }}
            >
              {params.data.shiftOTEnable}
            </span>
          </>
        );
      },
    },
    {
      headerName: "Shift HD Limits",
      field: "shiftHDLimits",
      width: "140px",
      cellRenderer: (params) => {
        return (
          <>
            <div>
              <div>{params.data.shiftHDLimits.start}</div>
              <p style={{ marginLeft: "16px" }}>|</p>
              <div>{params.data.shiftHDLimits.end}</div>
            </div>
          </>
        );
      },
    },

    {
      headerName: "Min.Working Hrs",
      field: "shiftMinWorkingHrs",
      filter: true,
      width: "175px",
    },

    {
      headerName: "Less Time After",
      field: "shiftLessTimeAfter",
      filter: true,
      width: "175px",
    },
    {
      headerName: "Maker OT after",
      field: "shiftMarkOTAfter",
      filter: true,
    },
    {
      headerName: "Actions",
      field: "actions",
      width: "100px",
      cellRenderer: (params) => {
        return (
          <>
            <div className="flex">
              {!params.data.isAssigned && (
                <>
                  <span className="shi-pen ml-2">
                    <PlusOutlined
                      onClick={() => activeBtnShift(params?.data?.item)}
                    />
                  </span>{" "}
                </>
              )}
            </div>
          </>
        );
      },
    },
  ];

  function formatTime(milliseconds) {
    const hours = Math.floor(milliseconds / 3600000);
    const minutes = Math.round((milliseconds % 3600000) / 60000);

    if (hours > 0) {
      return `${hours}:${minutes < 10 ? "0" : ""}${minutes} hr`;
    } else {
      return `${minutes} min`;
    }
  }
  function formatTimeWithAMPM(milliseconds) {
    const hours = Math.floor(milliseconds / 3600000);
    const minutes = Math.round((milliseconds % 3600000) / 60000);

    const formattedHours = hours % 12 || 12;
    const ampm = hours >= 12 ? "PM" : "AM";

    return `${formattedHours}:${minutes < 10 ? "0" : ""}${minutes} ${ampm}`;
  }
  const data = shiftsData.map((item, index) => ({
    key: index,
    shiftId: item.shiftId,
    isAssigned: item.isAssigned,
    shiftShortName: capitalizeFirstLetter(item.shiftShortName),
    shiftFullName: capitalizeFirstLetter(item.shiftFullName),
    shiftDescription: capitalizeFirstLetter(item.shiftDescription),
    time: { start: item.shiftStartTime, end: item.shiftEndTime },

    shiftMinWorkingHrs: formatTime(item.shiftMinWorkingHrs),
    shiftLateEarlyTime: formatTime(item.shiftLateEarlyTime),
    shiftLessTimeAfter: formatTime(item.shiftLessTimeAfter),
    shiftHDLimits: {
      start: formatTime(item.shiftHDLimitsStart),
      end: formatTime(item.shiftHDLimitsEnd),
    },

    shiftHDLimitsStart: formatTime(item.shiftHDLimitsStart),
    shiftHDLimitsEnd: formatTime(item.shiftHDLimitsEnd),
    shiftOTEnable: item.shiftOTEnable ? "Yes" : "No",
    shiftMarkOTAfter: formatTime(item.shiftMarkOTAfter),

    actions: (
      <div
        className="flex"
        style={{ justifyContent: "center", display: "flex" }}
      >
        <BsPencil
          style={{
            border: "1px solid #D7E7F8",
            padding: "3px",
            backgroundColor: "#D7E7F8",
            borderRadius: "50%",
            fontSize: "17px",
          }}
        />
        <StopOutlined
          style={{
            border: "1px solid #D7E7F8",
            padding: "3px",
            backgroundColor: "#F5E7E9",
            borderRadius: "50%",
            fontSize: "10px",
            color: "#DC3545",
            marginLeft: "5px",
          }}
        />
      </div>
    ),
  }));
  const disabledData = shiftsDisabledData.map((item, index) => ({
    key: index,
    item: item,
    shiftId: item.shiftId,
    isAssigned: item.isAssigned,
    shiftShortName: capitalizeFirstLetter(item.shiftShortName),
    shiftFullName: capitalizeFirstLetter(item.shiftFullName),
    shiftDescription: capitalizeFirstLetter(item.shiftDescription),
    time: { start: item.shiftStartTime, end: item.shiftEndTime },

    shiftMinWorkingHrs: formatTime(item.shiftMinWorkingHrs),
    shiftLateEarlyTime: formatTime(item.shiftLateEarlyTime),
    shiftLessTimeAfter: formatTime(item.shiftLessTimeAfter),
    shiftHDLimits: {
      start: formatTime(item.shiftHDLimitsStart),
      end: formatTime(item.shiftHDLimitsEnd),
    },

    shiftHDLimitsStart: formatTime(item.shiftHDLimitsStart),
    shiftHDLimitsEnd: formatTime(item.shiftHDLimitsEnd),
    shiftOTEnable: item.shiftOTEnable ? "Yes" : "No",
    shiftMarkOTAfter: formatTime(item.shiftMarkOTAfter),

    actions: (
      <div
        className="flex"
        style={{ justifyContent: "center", display: "flex" }}
      >
        <BsPencil
          style={{
            border: "1px solid #D7E7F8",
            padding: "3px",
            backgroundColor: "#D7E7F8",
            borderRadius: "50%",
            fontSize: "17px",
          }}
        />
        <StopOutlined
          style={{
            border: "1px solid #D7E7F8",
            padding: "3px",
            backgroundColor: "#F5E7E9",
            borderRadius: "50%",
            fontSize: "10px",
            color: "#DC3545",
            marginLeft: "5px",
          }}
        />
      </div>
    ),
  }));

  return (
    <div>
      <ToastContainer position="top-right" autoClose={2000} />

      <div className="flex justify-between mt-3 items-center">
        <p className="text-[17px] text-[#4B8AEB] font-sbold my-0 relative top-2">
          Active Shift
        </p>
        <button
          onClick={() => showForm(null)}
          className="h-[35px] border !border-[#00305F] !px-5 inline-flex items-center rounded-full font-sbold hover:bg-[#00305F] hover:text-white cursor-pointer transition-all"
        >
          +Add New Shift
        </button>
      </div>

      <div
        className="ag-theme-alpine text-base border-none font-proxima tableBordered"
        style={{ height: "auto", width: "100%", marginTop: "10px" }}
      >
        <AgGridReact
          gridOptions={gridOptions}
          columnDefs={columns}
          rowData={data}
          pagination={true}
          paginationPageSize={20}
          getRowHeight={() => 80}
          domLayout="autoHeight"
          paginationPageSizeSelector={false}
        />
      </div>
      <p className="text-[17px] text-[#4B8AEB] font-sbold mt-0 mb-3 relative top-2">
        Disabled Shift
      </p>
      <div
        className="ag-theme-alpine text-base border-none font-proxima"
        style={{ height: "auto", width: "100%", marginTop: "10px" }}
      >
        <AgGridReact
          gridOptions={gridOptions}
          className="fw600"
          columnDefs={disabledColumns}
          rowData={disabledData}
          pagination={true}
          paginationPageSize={20}
          getRowHeight={() => 80}
          domLayout="autoHeight"
          paginationPageSizeSelector={false}
        />
      </div>
      <ShiftForm
        visible={formVisible}
        onCancel={hideForm}
        onAddOrUpdate={handleAddOrUpdate}
        initialValues={editItem}
        isEdit={editItem !== null}
      />
      <ModalConfirm
        visible={modalDeleteShiftVisible}
        onOk={() => handleOk(deleteShiftData)}
        onCancel={handleCancel}
        title="Disable"
        content="Are you sure you want to disable?"
      />
      <ModalConfirm
        visible={modalActiveShiftVisible}
        onOk={() => handleActiveOk(activeShiftData)}
        onCancel={handleActiveCancel}
        title="Enable"
        content="Are you sure you want to enable?"
      />
    </div>
  );
}

export default Shift;
